import React, { useEffect, useState } from "react";
import {
  stuacademicyearlist,
  stuclasslist,
  studivisionlist,
} from "../../../services/master";
import { studentfilter, studentleft } from "../../../services/student";
import Select from "react-select";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { academylist } from "../../../services/admin";
import moment from "moment";

export default function Leftstudent() {
  const navigate = useNavigate();
  const [alist, setAList] = useState([]);
  const [clslist, setClsList] = useState([]);
  const [seclist, setSecList] = useState([]);
  const [stulist, setStuList] = useState([]);
  const [slist, setSList] = useState([]);

  const [ayear, setAYear] = useState("");
  const [stucls, setStuCls] = useState("");
  const [stusec, setStuSec] = useState("");
  const [stuid, setStuId] = useState("");
  const [stuphoto, setStuPhoto] = useState("");
  const [spath, setStuPath] = useState("");
  const [ldate, setLDate] = useState("");
  const [scond, setSCond] = useState("");
  const [lreason, setLReason] = useState("");
  const [lremark, setLRemark] = useState("");
  const [lpromote, setLPromote] = useState("");
  const [ltcno, setLTCNo] = useState("");

  const [aclist, setAcList] = useState([]);
  const [acaid, setAcaID] = useState("");
  useEffect(() => {
 
if(localStorage.getItem("ADate") !== ''){
      setLDate(moment(localStorage.getItem("ADate")).format("YYYY-MM-DD"));
    }else{
      setLDate(moment(new Date()).format("YYYY-MM-DD"));
    }
    

    stuclasslist().then((res) => {
      if (res.status === true) {
        setClsList(res.data);
      }
    });

    studivisionlist().then((res) => {
      if (res.status === true) {
        setSecList(res.data);
      }
    });

    academylist().then((res) => {
      if (res.status === true) {
        let arr = [];
        if (res.data.details.length > 0) {
          for (let i = 0; i < res.data.details.length; i++) {
            arr.push({
              value: res.data.details[i].id,
              label:
                res.data.details[i].name + " - " + res.data.details[i].code,
            });
          }
          setAcList(arr);
        }
      }
    });
 
     if (localStorage.getItem("AAcademy") != null) {
            academylist().then((res) => {
              if (res.status === true) {
                let arr = [];
                if (res.data.details.length > 0) {
                  for (let i = 0; i < res.data.details.length; i++) {
                    if (res.data.details[i].id == localStorage.getItem("AAcademy")) {
                      arr.push({
                        value: res.data.details[i].id,
                        label:
                          res.data.details[i].name + " - " + res.data.details[i].code,
                      });
                    }
                    if (arr.length > 0) {
                      setAcaID(arr[0]);
                      listyear(arr[0]);
                      setAYear(localStorage.getItem("AYear"));
                    }
                  }
                 
                }
              }
            });
          }else{
            listyear("");
          }

  }, []);

  function filterstu(aca, yr, cl, se) {
    setStuPath("");
    setSList([]);
    setStuList([]);
    setStuId("");
    setStuPhoto("");
    if (yr !== "" && cl !== "" && se !== "") {
      const temp = new FormData();
      temp.append("year", yr);
      temp.append("class", cl);
      temp.append("section", se);
      if (localStorage.getItem("Role") === "1" && aca !== "") {
        temp.append("academy", aca.value);
      }
      studentfilter(temp).then((res) => {
        if (res.status === true) {
          let arr = [];
          setStuPath(res.data.path);
          setSList(res.data.details);
          if (res.data.details.length > 0) {
            for (let i = 0; i < res.data.details.length; i++) {
              arr.push({
                value: res.data.details[i].id,
                label:
                  res.data.details[i].username +
                  " - " +
                  res.data.details[i].student_name,
              });
            }
          }
          setStuList(arr);
        }
      });
    }
  }

  function handleStu(e) {
    setStuPhoto("");
    if (e !== null) {
      setStuId(e);
      if (slist.length > 0) {
        const rdata = slist.find((item) => item.id == e.value);

        if (rdata !== undefined) {
          if (rdata.photo !== null) {
            setStuPhoto(spath + rdata.photo);
          }
        }
      }
    } else {
      setStuId("");
      setStuPhoto("");
    }
  }
  function errorphoto(ev) {
    ev.target.src = require("../../../assets/images/user.png");
    ev.target.onerror = null;
  }
  const [errmsg, setErrMsg] = useState("");
  function subleft(e) {
    e.preventDefault();
    setErrMsg("");
    let valid = "";
    if (localStorage.getItem("Role") === "1") {
      if (acaid === "") {
        setErrMsg("Please Select Academy");
        valid = "Please Select Academy";
      }
    } else {
      valid = "";
    }
    if (valid === "") {
      if (ayear !== "") {
        if (stucls !== "") {
          if (stusec !== "") {
            if (stuid !== "") {
              if (ldate !== "") {
                if (scond !== "") {
                  if (lreason !== "") {
                    setLoading(true);
                    const temp = new FormData();
                    temp.append("stu_id", stuid.value);
                    temp.append("year", ayear);
                    temp.append("class", stucls);
                    temp.append("section", stusec);
                    temp.append("left_date", ldate);
                    temp.append("conduct", scond);
                    temp.append("reason", lreason);
                    temp.append("remark", lremark);
                    temp.append("promote", lpromote);
                    temp.append("tc_no", ltcno);
                    if (localStorage.getItem("Role") === "1" && acaid !== "") {
                      temp.append("academy", acaid.value);
                    }
                    studentleft(temp).then((res) => {
                      if (res.status === true) {
                        setLoading(false);
                        navigate("/student/leftstudentlist");
                        toast.success(res.message);
                      } else {
                        setLoading(false);
                        toast.error(res.message);
                      }
                    });
                  } else {
                    setErrMsg("Please Enter Left Reason");
                  }
                } else {
                  setErrMsg("Please Enter Conduct");
                }
              } else {
                setErrMsg("Please Select Left Date");
              }
            } else {
              setErrMsg("Please Select Student");
            }
          } else {
            setErrMsg("Please Select Section");
          }
        } else {
          setErrMsg("Please Select Class");
        }
      } else {
        setErrMsg("Please Select Academic Year");
      }
    }
  }

  function handleAcademy(e) {
    if (e !== null) {
      setAcaID(e);
      filterstu(e, ayear, stucls, stusec);
      listyear(e);
    } else {
      setAcaID("");
      filterstu("", ayear, stucls, stusec);
      listyear("");
    }
  }

  function listyear(aid){
        setAList([]);
        setAYear("");
        const temp = new FormData();
        if (localStorage.getItem("Role") === "1" && aid !== "") {
          temp.append("academy_id", aid.value);
        }
        stuacademicyearlist(temp).then((res) => {
          if (res.status === true) {
            setAList(res.data);
          }
        });
      }

  const [loading, setLoading] = useState(false);
  return (
    <div>
      <div className="page-header">
        <h2 className="main-content-title tx-24 mg-b-5">Left Students</h2>
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <a>Students</a>
          </li>
          <li className="breadcrumb-item active" aria-current="page">
            Left Students
          </li>
        </ol>
      </div>

      {loading && (
        <div className="loader-wrapper">
          <div className="loader"></div>
          <h3>Loading...Please do not go back or close the window.</h3>
        </div>
      )}
      {!loading && (
        <div className="content-body">
          <div className="container-fluid">
            <div className="row">
              <div className="col-xl-12">
                <div className="card">
                  <div className="card-header">
                    <h2 className="main-content-title tx-24 mg-b-5">
                      Left Student
                    </h2>
                  </div>
                  <div className="card-body">
                    <div className="row">
                      <div className="col-xl-3 col-lg-4">
                        <label className="form-label">Photo</label>
                        <div className="avatar-upload">
                          <div className="avatar-preview">
                            <img
                              src={stuphoto}
                              onError={(e) => errorphoto(e)}
                              alt="Student"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-xl-9 col-lg-8">
                        <div className="row">
                          {localStorage.getItem("Role") === "1" && (
                            <div className="col-xl-6 col-sm-6">
                              <div className="mb-3">
                                <label className="form-label">
                                  Select Academy{" "}
                                  <span className="text-danger"> *</span>
                                </label>
                                <Select
                                  className="default-select"
                                  placeholder="Select Academy"
                                  value={acaid}
                                  options={aclist}
                                  onChange={handleAcademy}
                                  isSearchable={true}
                                  isClearable
                                  hidden
                                />
                              </div>
                            </div>
                          )}
                          <div className="col-xl-6 col-sm-6">
                            <div className="mb-3">
                              <label className="form-label">
                                Academic Year
                                <span className="text-danger"> *</span>
                              </label>
                              <select
                                className="default-select  form-control wide"
                                value={ayear}
                                onChange={(e) => setAYear(e.target.value)}
                                onBlur={(e) =>
                                  filterstu(
                                    acaid,
                                    e.target.value,
                                    stucls,
                                    stusec
                                  )
                                }
                              >
                                <option value="" disabled>
                                  Select Academic Year
                                </option>
                                {alist.map((item, i) => {
                                  return (
                                    <option value={item.id} key={i}>
                                      {item.aca_year}
                                    </option>
                                  );
                                })}
                              </select>
                            </div>
                          </div>
                          <div className="col-xl-6 col-sm-6">
                            <div className="mb-3">
                              <label className="form-label">
                                Class <span className="text-danger"> *</span>
                              </label>
                              <select
                                className="default-select  form-control wide"
                                value={stucls}
                                onChange={(e) => setStuCls(e.target.value)}
                                onBlur={(e) =>
                                  filterstu(
                                    acaid,
                                    ayear,
                                    e.target.value,
                                    stusec
                                  )
                                }
                              >
                                <option value="" disabled>
                                  Select Class
                                </option>
                                {clslist.map((item, i) => {
                                  return (
                                    <option value={item.id} key={i}>
                                      {item.class_name}
                                    </option>
                                  );
                                })}
                              </select>
                            </div>
                          </div>
                          <div className="col-xl-6 col-sm-6">
                            <div className="mb-3">
                              <label className="form-label">
                                Section<span className="text-danger"> *</span>
                              </label>
                              <select
                                className="default-select  form-control wide"
                                value={stusec}
                                onChange={(e) => setStuSec(e.target.value)}
                                onBlur={(e) =>
                                  filterstu(
                                    acaid,
                                    ayear,
                                    stucls,
                                    e.target.value
                                  )
                                }
                              >
                                <option value="" disabled>
                                  Select Section
                                </option>
                                {seclist.map((item, i) => {
                                  return (
                                    <option value={item.id} key={i}>
                                      {item.name}
                                    </option>
                                  );
                                })}
                              </select>
                            </div>
                          </div>
                          <div className="col-xl-6 col-sm-6">
                            <div className="mb-3">
                              <label className="form-label">
                                Student Name
                                <span className="text-danger"> *</span>
                              </label>
                              <Select
                                className="default-select"
                                placeholder="Select Student"
                                value={stuid}
                                options={stulist}
                                onChange={handleStu}
                                isSearchable={true}
                                isClearable
                                hidden
                              />
                            </div>
                          </div>
                          <div className="col-xl-6 col-sm-6">
                            <div className="mb-3">
                              <label className="form-label">
                                Date Of Left
                                <span className="text-danger"> *</span>
                              </label>
                              <div className="input-group">
                                <input
                                  className="form-control"
                                  type="date"
                                  value={ldate}
                                  onChange={(e) => setLDate(e.target.value)}
                                  onKeyPress={(event) => {
                                    event.preventDefault();
                                  }}
                                  onKeyDown={(event) => {
                                    event.preventDefault();
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                          <div className="col-xl-6 col-sm-6">
                            <div className="mb-3">
                              <label className="form-label">
                                Conduct
                                <span className="text-danger">
                                  {" "}
                                  * (Eg: Good, Fair, Poor)
                                </span>
                              </label>
                              <input
                                className="form-control"
                                type="text"
                                placeholder="Enter Conduct"
                                value={scond}
                                onChange={(e) => setSCond(e.target.value)}
                              />
                            </div>
                          </div>
                          <div className="col-xl-6 col-sm-6">
                            <div className="mb-3">
                              <label className="form-label">
                                Left Reason
                                <span className="text-danger"> *</span>
                              </label>
                              <input
                                className="form-control"
                                type="text"
                                placeholder="Enter Reason"
                                value={lreason}
                                onChange={(e) => setLReason(e.target.value)}
                              />
                            </div>
                          </div>
                          <div className="col-xl-6 col-sm-6">
                            <div className="mb-3">
                              <label className="form-label">Remark</label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter Remark"
                                value={lremark}
                                onChange={(e) => setLRemark(e.target.value)}
                              />
                            </div>
                          </div>
                          <div className="col-xl-6 col-sm-6">
                            <div className="mb-3">
                              <label className="form-label">
                                Promoted To
                                {/* <span className="text-danger"> *</span> */}
                              </label>
                              <select
                                className="default-select  form-control wide"
                                value={lpromote}
                                onChange={(e) => setLPromote(e.target.value)}
                              >
                                <option value="" disabled>
                                  Select Promoted Class
                                </option>
                                {clslist.map((item, i) => {
                                  return (
                                    <option value={item.id} key={i}>
                                      {item.class_name}
                                    </option>
                                  );
                                })}
                              </select>
                            </div>
                          </div>

                          <div className="col-xl-6 col-sm-6">
                            <div className="mb-3">
                              <label className="form-label">
                                TC Number
                                {/* <span className="text-danger"> *</span> */}
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="TC Number"
                                value={ltcno}
                                onChange={(e) => setLTCNo(e.target.value)}
                              />
                            </div>
                          </div>
                        </div>
                        {errmsg !== "" && (
                          <span className="text-danger">{errmsg}</span>
                        )}
                        <div className="res-right">
                          <button
                            className="btn btn-success me-2"
                            onClick={subleft}
                          >
                            Submit
                          </button>
                          <button
                            className="btn btn-secondary"
                            onClick={() => navigate("/student/leftstudentlist")}
                          >
                            Back
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
